import { render } from "./JobBoardPage.vue?vue&type=template&id=6f77caea&scoped=true&ts=true"
import script from "./JobBoardPage.vue?vue&type=script&lang=ts"
export * from "./JobBoardPage.vue?vue&type=script&lang=ts"

import "./JobBoardPage.vue?vue&type=style&index=0&id=6f77caea&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f77caea"]])

export default __exports__